export default ConfirmButton;

/** Wrapper for confirm buttons
 *
 * @param $button
 * @attributes confirm-message
 * @returns {{}}
 * @constructor
 */

function ConfirmButton($button)
{
    var buttonConfirmed = false;
    $button.click(onClick);

    function onClick(e)
    {
        var $popup = $(".confirmPopup").clone();
        $popup.addClass('.duplicate');
        $popup.find('.message').html($(this).attr('confirm-message'));

        var $confirm = $popup.find('.confirmButton');
        var $cancel = $popup.find('.cancelButton');

        $confirm.on('click',function(){
            buttonConfirmed = true;
            $button.addClass('confirmed');
            $button.off('click',onClick);
            $popup.modal('hide');
            return true;

        });

        $popup.modal();

        $popup.on('hidden.bs.modal',function(){
            $popup.remove();
            if(buttonConfirmed)
            {
                $button[0].click();
            }
        });

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    }

    var comp = {};
    comp.element = $button;
    return comp;
}
